<template>
  <div class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="12" class="h-full">
        <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
          <el-row class="flex">
            <selectStandardId @updateStandardId="updateStandardId" />
            <el-input
              size="small"
              v-model="leftCode"
              clearable
              :placeholder="$t('codeOrName')"
              class="mx-10px w-200px"
            />
            <el-button type="primary" @click="searchLeftList">{{ $t('search') }}</el-button>
            <el-button type="primary" :disabled="!$hasAccess('create')" @click="addLeft()">{{
              $t('create')
            }}</el-button>
            <el-button
              type="danger"
              :disabled="!$hasAccess('delete')"
              @click.stop="delLeft(leftIdList)"
              >{{ $t('delete') }}</el-button
            >
            <el-button size="small" :loading="exportLoading" @click="exportFile">{{
              $t('export')
            }}</el-button>
            <el-button size="small" @click="importFile">{{ $t('import') }}</el-button>
          </el-row>
          <el-table
            class="mt-20px"
            border
            :data="leftData"
            v-loading="leftLoading"
            :highlight-current-row="true"
            @selection-change="leftSelectionChange"
            @row-click="leftRowClick"
            height="calc(100% - 102px)"
            ref="leftTable"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="`${$t('seqNo')}`" type="index" width="55"></el-table-column>
            <el-table-column :label="$t('数据标准库')" prop="standardName"></el-table-column>
            <el-table-column :label="`${$t('code')}`" prop="code"></el-table-column>
            <el-table-column :label="`${$t('name')}`" prop="name"></el-table-column>
            <el-table-column :label="`${$t('description')}`" prop="description"> </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('update')"
                  @click="editLeft(scope.row)"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('delete')"
                  @click="delLeft([scope.row.id])"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px float-right"
            background
            @current-change="handleCurrentLeft"
            @size-change="handleSizeLeft"
            :current-page.sync="leftPage.pageNo"
            :page-size="leftPage.pageSize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="leftPage.total"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="12" class="h-full">
        <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
          <el-row class="flex">
            <el-input
              size="small"
              v-model="rightCode"
              clearable
              :placeholder="$t('codeOrName')"
              class="mr-10px w-200px"
            />
            <el-button type="primary" @click="searchRight()">{{ $t('search') }}</el-button>
            <el-button type="primary" :disabled="!$hasAccess('create')" @click="addRight()">{{
              $t('create')
            }}</el-button>
            <el-button
              type="danger"
              :disabled="!$hasAccess('delete')"
              @click.stop="delRight(rightIdList)"
              >{{ $t('delete') }}</el-button
            >
          </el-row>
          <el-table
            border
            :data="rightData"
            v-loading="rightLoading"
            :highlight-current-row="true"
            @selection-change="rightSelectionChange"
            @row-click="rightRowClick"
            height="calc(100% - 102px)"
            ref="multipleTable"
            class="mt-20px"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="`${$t('seqNo')}`" type="index" width="55"></el-table-column>
            <el-table-column :label="`${$t('code')}`" prop="code"></el-table-column>
            <el-table-column :label="`${$t('name')}`" prop="name"></el-table-column>
            <el-table-column :label="`${$t('value')}`" prop="value"></el-table-column>
            <el-table-column :label="`${$t('description')}`" prop="description"> </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('update')"
                  @click="editRight(scope.row)"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('delete')"
                  @click="delRight([scope.row.id])"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px float-right"
            background
            @current-change="handleCurrentRight"
            @size-change="handleSizeRight"
            :current-page.sync="rightPage.pageNo"
            :page-size="rightPage.pageSize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rightPage.total"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
    <!-- 新增类别 -->
    <el-dialog
      :title="leftDialogTitle"
      :visible.sync="leftDialog"
      :close-on-click-modal="false"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form :model="leftForm" :rules="leftRules" ref="leftForm" label-width="150px">
        <el-form-item label="标准库" prop="standardId">
          <el-select
            v-model="leftForm.standardId"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            disabled
          >
            <el-option
              v-for="item in standardIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('code')" prop="code">
          <el-input size="small" v-model="leftForm.code" clearable />
        </el-form-item>
        <el-form-item :label="$t('name')" prop="name">
          <el-input size="small" v-model="leftForm.name" clearable />
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input size="small" v-model="leftForm.description" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="checkNameIsExist" :loading="leftSaveLoading">{{
          $t('save')
        }}</el-button>
        <el-button @click="leftDialog = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增字典值 -->
    <el-dialog
      :title="rightDialogTitle"
      :visible.sync="rightDialog"
      :close-on-click-modal="false"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form :model="rightForm" :rules="rightRules" ref="rightForm" label-width="150px">
        <el-form-item :label="$t('category')" prop="cateId">
          <el-select size="small" v-model="rightForm.cateId" clearable filterable disabled>
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('code')" prop="code">
          <el-input size="small" v-model="rightForm.code" clearable @input="syncValue" />
        </el-form-item>
        <el-form-item :label="$t('name')" prop="name">
          <el-input size="small" v-model="rightForm.name" clearable />
        </el-form-item>
        <el-form-item :label="$t('value')" prop="value">
          <el-input size="small" v-model="rightForm.value" clearable />
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input size="small" v-model="rightForm.description" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="rightSave" :loading="rightSaveLoading">{{
          $t('save')
        }}</el-button>
        <el-button @click="rightDialog = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 导入弹框 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchLeftList"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script>
import CommonService from '@/services/Common'
import ReferenceDataService from '@/services/ReferenceDataService'
import StandardManagementService from '@/services/common/StandardManagementService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
import dayjs from 'dayjs'

export default {
  components: {
    selectStandardId,
  },
  mixins: [fnMixin],
  data() {
    return {
      // left
      leftCode: '',
      leftData: [],
      leftLoading: false,
      leftSelect: [],
      leftPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      leftDialogTitle: '',
      leftDialog: false,
      leftForm: {
        standardId: localStorage.getItem('standardId'),
        code: '',
        name: '',
        description: '',
      },
      leftRules: {},
      leftSaveLoading: false,
      leftCurrentRow: {},
      // right
      rightCode: '',
      rightData: [],
      rightLoading: false,
      rightSelect: [],
      rightCurrentRow: {},
      rightPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      rightDialogTitle: '',
      rightDialog: false,
      rightForm: {
        cateId: '',
        code: '',
        name: '',
        value: '',
        description: '',
      },
      rightRules: {},
      rightSaveLoading: false,
      categoryList: [],
      leftIdList: [],
      rightIdList: [],
      standardId: localStorage.getItem('standardId'),
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      standardIdList: [],
      exportLoading: false,
    }
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.searchLeft()
    },
    // 导出
    async exportFile() {
      const params = {
        standardId: this.standardId,
        filter: this.leftCode,
      }
      if (this.leftIdList.length > 0) {
        params.cateIds = this.leftIdList
      }
      this.exportLoading = true
      const res = await ReferenceDataService.exportReferenceDataCate(params)
      this.exportLoading = false
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '参考数据导出结果.xlsx',
          data: res,
        })
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/ReferenceDataCate/download-template',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '参考数据导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadFile({
        reqUrl: 'std/ReferenceDataCate/import',
        reqData: formData,
      })
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '参考数据导入明细.xlsx',
          data: res,
        })
        this.searchLeft()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 左侧表格搜索
    searchLeftList() {
      this.leftPage.pageNo = 1
      this.searchLeft()
    },
    async searchLeft() {
      this.leftLoading = true
      const params = {
        standardId: this.standardId,
        Code: this.leftCode,
        Sorting: '',
        SkipCount: (this.leftPage.pageNo - 1) * this.leftPage.pageSize,
        MaxResultCount: this.leftPage.pageSize,
      }
      const res = await ReferenceDataService.getCategory(params)
      this.leftLoading = false
      if (res && res.code === 0 && res.data) {
        this.leftData = res.data.map((item) => {
          this.standardIdList.forEach((val) => {
            if (val.id === item.standardId) {
              item.standardName = val.name
            }
          })
          return item
        })
        this.leftPage.total = res.totalCount
      }
    },
    async addLeft() {
      this.leftDialogTitle = this.$t('createClass')
      this.leftDialog = true
      this.leftForm = this.$options.data().leftForm
      if (localStorage.getItem('standardList')) {
        this.standardIdList = JSON.parse(localStorage.getItem('standardList'))
      } else {
        this.standardIdList = await this.getStandardList()
      }
      if (this.$refs.leftForm) {
        this.$refs.leftForm.clearValidate()
      }
    },
    editLeft(row) {
      this.leftDialogTitle = this.$t('editClass')
      this.leftDialog = true
      this.leftForm = _.cloneDeep(row)
    },
    leftSave() {
      this.$refs.leftForm.validate(async (valid) => {
        if (valid) {
          this.leftSaveLoading = true
          let res
          if (this.leftForm.id) {
            res = await ReferenceDataService.editCategory(this.leftForm)
          } else {
            res = await ReferenceDataService.addCategory(this.leftForm)
          }
          this.leftSaveLoading = false
          if (res && res.code === 0) {
            this.$message.success(this.$t('saveSuccessFul'))
            this.leftDialog = false
            await this.searchLeft()
            this.$nextTick(() => {
              this.$refs.leftTable.setCurrentRow(this.leftData[0])
            })
            this.leftForm = this.$options.data().leftForm
          }
        }
      })
    },
    async checkNameIsExist() {
      const res = await ReferenceDataService.checkNameExisted({ name: this.leftForm.name })
      console.log('res', res)

      if (res && res.code === 0) {
        if (res.data) {
          this.$confirm(this.$t('confirmContinueIgnoreIsExist'), this.$t('tip'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          }).then(() => {
            this.leftSave()
          })
        } else {
          this.leftSave()
        }
      }
    },
    delLeft(id) {
      if (id.length) {
        this.$confirm(this.$t('confirmDeleteAttribute'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(async () => {
          const res = await ReferenceDataService.deleteCategory(id)
          if (res && res.code === 0) {
            this.$message.success(this.$t('DeleteSuccessful'))
            this.searchLeft()
          }
        })
      } else {
        this.$message.info(this.$t('pleaseSelectTheDataToDelete'))
      }
    },
    leftSelectionChange(val) {
      this.leftSelect = val
      this.leftIdList = _.map(this.leftSelect, (item) => {
        return item.id
      })
    },
    handleCurrentLeft(num) {
      this.leftPage.pageNo = num
      this.searchLeft()
    },
    handleSizeLeft(size) {
      this.leftPage.pageSize = size
      this.searchLeft()
    },
    leftRowClick(row) {
      this.leftCurrentRow = row
      this.searchRight()
    },
    async searchRight() {
      const params = {
        Code: this.rightCode,
        Sorting: '',
        SkipCount: this.rightPage.pageNo,
        MaxResultCount: this.rightPage.pageSize,
        cateId: this.leftCurrentRow.id,
      }
      this.rightLoading = true
      const res = await ReferenceDataService.getCategoryItem(params)
      this.rightLoading = false
      if (res && res.code === 0 && res.data) {
        this.rightData = res.data.sort((a, b) => {
          return dayjs(a.createdTime) - dayjs(b.createdTime)
        })
        this.rightPage.total = res.totalCount
      }
    },
    addRight() {
      this.rightDialogTitle = this.$t('addDictionaryEntries')
      this.rightDialog = true
      this.rightForm = this.$options.data().rightForm
      if (this.$refs.rightForm) {
        this.$refs.rightForm.resetFields()
      }
      this.getCategory()
      if (!_.isEmpty(this.leftCurrentRow)) {
        this.rightForm.cateId = this.leftCurrentRow.id
      }
      this.leftForm.standardId = this.standardId
    },
    editRight(row) {
      this.rightDialogTitle = this.$t('editDictionaryEntries')
      this.rightDialog = true
      this.rightForm = _.cloneDeep(row)
      this.getCategory()
    },
    rightSave() {
      this.$refs.rightForm.validate(async (valid) => {
        if (valid) {
          this.rightSaveLoading = true
          let res
          if (this.rightForm.id) {
            res = await ReferenceDataService.editCategoryItem(this.rightForm)
          } else {
            res = await ReferenceDataService.addCategoryItem(this.rightForm)
          }
          this.rightSaveLoading = false
          if (res && res.code === 0) {
            this.$message.success(this.$t('saveSuccessFul'))
            this.rightDialog = false
            this.searchRight()
            this.rightForm = this.$options.data().rightForm
          }
        }
      })
    },
    delRight(id) {
      if (id.length) {
        this.$confirm(this.$t('confirmDeleteAttribute'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(async () => {
          const res = await ReferenceDataService.deleteCategoryItem(id)
          if (res && res.code === 0) {
            this.$message.success(this.$t('DeleteSuccessful'))
            this.searchRight()
          }
        })
      } else {
        this.$message.info(this.$t('pleaseSelectTheDataYouWantToDelete'))
      }
    },
    rightSelectionChange(val) {
      this.rightSelect = val
      this.rightIdList = _.map(this.rightSelect, (item) => {
        return item.id
      })
    },
    rightRowClick(val) {
      this.rightCurrentRow = val
    },
    handleCurrentRight(num) {
      this.rightPage.pageNo = num
      this.searchRight()
    },
    handleSizeRight(size) {
      this.rightPage.pageSize = size
      this.searchRight()
    },
    async getCategory() {
      const params = {
        SkipCount: 0,
        MaxResultCount: 999,
      }
      const res = await ReferenceDataService.getCategory(params)
      if (res && res.code === 0 && res.data) {
        this.categoryList = res.data
      }
    },
    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        return res.data
      }
      return []
    },
    // code输入时同步到字典值
    syncValue(event) {
      this.rightForm.value = event
    },
  },
  async created() {
    this.leftRules = {
      standardId: [{ required: true, message: '请选择标准库', trigger: 'change' }],
      code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' }],
      name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'change' }],
    }
    this.rightRules = {
      cateId: [{ required: true, message: this.$t('PleaseSelectACategory'), trigger: 'change' }],
      code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' }],
      name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'change' }],
      value: [{ required: true, message: this.$t('enterTheDictionaryValue'), trigger: 'change' }],
    }
    this.searchLeft()
    this.standardIdList = JSON.parse(localStorage.getItem('standardList'))
  },
}
</script>

<style lang="scss" scoped>

.w-200 {
  width: 200px !important;
}

</style>
